var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.82153,
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0004 13.8215C11.1595 13.8215 9.66707 12.3291 9.66707 10.4881C9.66707 8.64717 11.1595 7.15479 13.0004 7.15479C14.8414 7.15479 16.3337 8.64717 16.3337 10.4881C16.3337 12.3291 14.8414 13.8215 13.0004 13.8215ZM13.0004 12.4881C14.105 12.4881 15.0004 11.5927 15.0004 10.4881C15.0004 9.38355 14.105 8.48812 13.0004 8.48812C11.8958 8.48812 11.0004 9.38355 11.0004 10.4881C11.0004 11.5927 11.8958 12.4881 13.0004 12.4881Z",
    fill: "#1A4C92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66707 17.377V20.4881H6.33374V17.377C6.33374 16.1626 7.39392 15.1548 8.63677 15.1548H17.364C18.6069 15.1548 19.6671 16.1626 19.6671 17.377V20.4881H18.3337V17.377C18.3337 16.9145 17.8852 16.4881 17.364 16.4881H8.63677C8.11562 16.4881 7.66707 16.9145 7.66707 17.377Z",
    fill: "#1A4C92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 1.82153H3C1.89543 1.82153 1 2.71696 1 3.82153V6.62153",
    stroke: "#1A4C92",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 25.8215H3C1.89543 25.8215 1 24.9261 1 23.8215V21.0215",
    stroke: "#1A4C92",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 1.82153H23C24.1046 1.82153 25 2.71696 25 3.82153V6.62153",
    stroke: "#1A4C92",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 25.8215H23C24.1046 25.8215 25 24.9261 25 23.8215V21.0215",
    stroke: "#1A4C92",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIcon);
export default __webpack_public_path__ + "static/media/faceIcon.b540694e0c161401fd3af8c1f332d4c6.svg";
export { ForwardRef as ReactComponent };